/* eslint-disable jsx-a11y/anchor-is-valid */
import { Avatar, Styles } from '@/components'
import useAuth from '@/hooks/useAuth'
import PropTypes from 'prop-types'
import React from 'react'
import { confirmAlert } from 'react-confirm-alert'
import { useHistory } from 'react-router-dom'
import useBreadcrumbs from 'use-react-router-breadcrumbs'
import * as HeaderStyles from './styles'

function Header({ routes }) {
  const auth = useAuth()
  const history = useHistory()

  const childrens = routes
    .filter(({ children }) => Boolean(children))
    .map(({ children }) => children)
  const breadcrumbs = useBreadcrumbs(
    [...routes.filter(({ path }) => path), ...childrens],
    {
      excludePaths: [
        '/app/castrations/status',
        '/app/castrations/status/:status/:id/*',
        '/app/clinical-cares/clinics/:id',
        '/app/batches/status',
        '/app/batches/status/:status/:id/*',
        '/app/clinics',
        '/app/clinics/:status/:id/*',
        '/app/protectors',
        '/app/news/form',
        '/app/regions/form',
        '/app/regions/:id',
        '/app/stalls/:id',
        '/app/manual-adoptions/form',
        '/app/protectors/:status/:id/*',
        '/app/mistreatments/status/:status/show',
        '/app/mistreatments/status/:status/show/:id/*',
        '/app/mistreatments/status',
        '/app/mistreatments/form',
        '/app/mistreatment-types/:id',
        '/app/adoption-fairs/:id/*',
        '/app/clinical-cares/status',
        '/app/clinical-cares/status/:status/:id/*',
        '/app/clinical-cares/form',
        '/app/ngos',
        '/app/ngos/:status/:id/*',
        '/app/settings',
        '/app/adoption-requested',
        '/app/manual-castrations/show',
      ],
    },
  )

  function handleSignOut() {
    confirmAlert({
      title: 'Sair do Petis',
      message: 'Você está certo que deseja fazer logout?',
      buttons: [
        { label: 'Não' },
        {
          label: 'Sim',
          className: 'bg-error',
          onClick: () => auth.signOut(() => {
            history.replace('/')
          }),
        },
      ],
    })
  }

  return (
    <Styles.Container style={{ zIndex: 9 }} className="grid-xl bg-light header-sticky no-print">
      <HeaderStyles.HiddenTop />
      <HeaderStyles.Navbar>
        <HeaderStyles.NavbarSection>
          <HeaderStyles.Breadcrumb>
            {breadcrumbs.filter(({ match }) => match.url !== '/').map(({
              match,
              breadcrumb,
            }) => (
              <HeaderStyles.BreadcrumbItem key={match.url}>
                <HeaderStyles.NavLink to={match.url}>
                  {breadcrumb}
                </HeaderStyles.NavLink>
              </HeaderStyles.BreadcrumbItem>
            ))}
          </HeaderStyles.Breadcrumb>
        </HeaderStyles.NavbarSection>
        <HeaderStyles.NavbarSection className="flex-centered">
          {
            auth.user
              ? (
                <div className="dropdown dropdown-right">
                  <a href="#" className="btn btn-link dropdown-toggle flex-centered" tabIndex="0">
                    <Avatar
                      name={auth?.user?.fullName}
                      photoURL={auth?.user?.photoURL}
                      alt="Imagem de usuário"
                    />
                    <span className="hide-lg">
                      &nbsp;{auth?.user?.fullName}
                    </span>
                    <i className="icon icon-caret" />
                  </a>
                  <ul className="menu">
                    <li className="menu-item">
                      <a onClick={handleSignOut} aria-hidden="true" className="text-error c-hand">
                        <i className="fas fa-sign-out-alt fa-fw" />
                        &nbsp;Sair
                      </a>
                    </li>
                  </ul>
                </div>
              )
              : null
          }
        </HeaderStyles.NavbarSection>
      </HeaderStyles.Navbar>
    </Styles.Container>
  )
}

Header.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.any).isRequired,
}

export default Header
